
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 20H2a2 2 0 01-2-2V2a2 2 0 012-2h7a.104.104 0 01.027 0h.006a.15.15 0 00.029.007c.088.006.175.023.259.05H9.363a.421.421 0 01.052.044.988.988 0 01.293.2l6 6a.987.987 0 01.2.293.735.735 0 01.023.066l.01.028c.028.083.044.17.049.258a.1.1 0 00.007.029v.006A.112.112 0 0116 7v11a2 2 0 01-2 2zM9 2v5h5L9 2z","fill":"#000","fill-rule":"nonzero"}})])
          )
        }
      }
    